// removed by extract-text-webpack-plugin
module.exports = {"gray":"S7b3e3F4CMwHRw6kmo4lO","item":"_2xtCFhw6cLsqYilzdtNPqq","radio":"_3tvYEZaBxOUWwPkbjZiQqc"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SingleCompanyInfo/SingleCompanyInfo.scss
 ** module id = 1039
 ** module chunks = 0
 **/